import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { Group } from 'lcmm-lib-js';
import { Sensorstation } from 'sensorstation-lib-js';
import { SensorstationLocation } from 'sensorstation-lib-js/dist/entities/sensorstation-location';
import { SensorstationService } from '../service/sensorstation.service';
import { SensorstationFormComponent } from '../sensorstation-form/sensorstation-form.component';

@Component({
  selector: 'app-sensorstation-create-dialog',
  templateUrl: './sensorstation-create-dialog.component.html',
  styleUrls: ['./sensorstation-create-dialog.component.scss'],
  standalone: false,
})
export class SensorstationCreateDialogComponent implements OnInit {
  public form: UntypedFormGroup;

  public groups: Group[];

  public sensorstation: Sensorstation;

  public loading = false;

  @ViewChild(SensorstationFormComponent)
  public sensorstationFormComponent: SensorstationFormComponent;

  constructor(
    public dialogRef: MatDialogRef<SensorstationCreateDialogComponent>,
    private sensorstationService: SensorstationService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      groups: Group[];
    }
  ) {
    this.initializeEmptySensorstation();
    this.groups = data.groups || [];
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({});
  }

  private initializeEmptySensorstation(): void {
    const sensorstationLocation: SensorstationLocation = {
      locationId: '',
      name: '',
      country: '',
      street: '',
      houseNumber: '',
      city: '',
      postalCode: '',
      state: '',
      latitude: null,
      longitude: null,
      sensorStations: ['string'],
    };

    this.sensorstation = {
      deviceId: '',
      aFESerialNumber: '',
      name: '',
      group: '',
      owner: '',
      locationId: '',
      location: sensorstationLocation,
      creationTimestamp: null,
      modifiedTimestamp: null,
      stationNumber: '',
    };
  }

  private _getSensorstation(): Sensorstation {
    const formValues = this.form.getRawValue().sensorstationForm;
    const locationValues = formValues.locationForm;

    const sensorstation: Sensorstation = {
      deviceId: formValues.deviceId || '',
      aFESerialNumber: formValues.aFESerialNumber || '',
      name: formValues.name || '',
      group: formValues.group || '',
      owner: formValues.owner || null,
      locationId: formValues.locationId || '',
      creationTimestamp: null,
      modifiedTimestamp: null,
      stationNumber: formValues.stationNumber || '',
      location: {
        locationId: locationValues.locationId || '',
        name: locationValues.name || '',
        country: locationValues.country || '',
        street: locationValues.street || '',
        houseNumber: locationValues.houseNumber || '',
        city: locationValues.city || '',
        postalCode: locationValues.postalCode || '',
        state: locationValues.state || '',
        latitude: locationValues.latitude || null,
        longitude: locationValues.longitude || null,
        sensorStations: locationValues.sensorStations || null,
      },
    };

    if (sensorstation.locationId) {
      sensorstation.location.locationId = sensorstation.locationId;
    }

    return sensorstation;
  }

  public onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    const sensorstation = this._getSensorstation();
    this.loading = true;
    this.sensorstationService.createSensorstation(sensorstation).subscribe(
      (createdSensorstation) => {
        this.loading = false;
        this.dialogRef.close(createdSensorstation);
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (err) => {
        this.loading = false;
      }
    );
  }

  public onClose(): void {
    this.dialogRef.close(null);
  }
}
